import { render } from "./opportunity-startup-details.vue?vue&type=template&id=09245c0d&ts=true"
import script from "./opportunity-startup-details.vue?vue&type=script&lang=ts"
export * from "./opportunity-startup-details.vue?vue&type=script&lang=ts"

import "./opportunity-startup-details.vue?vue&type=style&index=0&id=09245c0d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__